import { Title, Text } from "@mantine/core";
import adminClasses from "../AdminDashboardView/AdminDashboardView.module.css";
import classes from "./IssuanceDashboardView.module.css";

const IssuanceDashboardView = () => {
  return (
    <div className={adminClasses.page}>
      <div className={classes.wrapper}>
        <div className={classes.icon}>🚀</div>
        <Title className={classes.title}>Coming Soon</Title>
        <Text className={classes.subtitle}>
          Issuance Team Dashboard is under construction. Check back soon!
        </Text>
      </div>
    </div>
  );
};

export default IssuanceDashboardView;
